import type { PlanKind } from '@/modules/account'

export const PLANS = {
  SINGLE_PROJECT: 'Single Project',
  ANNUAL_CORE: 'CounselPro Core Annual',
  ANNUAL_PLUS: 'CounselPro Plus Annual',
  MONTHLY_CORE: 'CounselPro Core Monthly',
  MONTHLY_PLUS: 'CounselPro Plus Monthly',
} as const

export type PlanInterval = 'month' | 'year'

export interface PlanDTO {
  display_name: string
  nickname: string
  interval: PlanInterval
  currency: string
  unit_amount: number
  features: string[]
  pages_credit_grant: number
  screening_credit_grant: number
  price_id: string
  stripe_price_id: string
  kind: PlanKind
  product_name: string
}

export interface Plan {
  displayName: string
  nickname: string
  interval: PlanInterval
  currency: string
  unitAmount: number
  pagesCreditGrant: number
  screeningCreditGrant: number
  priceId: string
  stripePriceId: string
  features: string[]
  kind: PlanKind
  productName: string
}
